import "./App.css";

function App() {
  return (
    <div className="App">
      <p>Not a valid URL</p>
    </div>
  );
}

export default App;
